import React from 'react';

import { ButtonCategory, Dropdown, RadioGroup, useI18n } from '@freelancelabs/components';
import { GlobeOutline } from '@freelancelabs/icons';

interface Props {
    // Depends on the background: `inverse` on the accent aparte, `weak` on the light column.
    category?: ButtonCategory;
}

const LanguageSwitcher = ({ category = 'weak' }: Props) => {
    const { changeLocale, localeCode, availableLocales } = useI18n();

    const shouldDisplay = Object.keys(availableLocales).length > 1;

    const content = (
        <>
            <GlobeOutline /> <span className="truncate">{availableLocales[localeCode]}</span>
        </>
    );

    const options = Object.keys(availableLocales).map((value) => ({
        value,
        label: availableLocales[value],
    }));

    return (
        <>
            {shouldDisplay && (
                <Dropdown content={content} buttonCategory={category}>
                    <RadioGroup
                        className="px-2"
                        category="check"
                        value={localeCode}
                        options={options}
                        onValue={changeLocale}
                    />
                </Dropdown>
            )}
        </>
    );
};

export default LanguageSwitcher;
